import type { AxiosPromise } from 'axios';
import { type ClientContext, ContextClient } from '~/services/contextClient';
import ThreadCategoriesClientFactory from './threadCategoriesClient.factory';
import type {
    ThreadCategoriesClientInterface,
    ThreadCategoriesResponse,
    ThreadCategoryFormData,
} from './threadCategoriesClient.types';

class ThreadCategoriesClient extends ContextClient<ThreadCategoriesClientInterface> {
    constructor() {
        super(ThreadCategoriesClientFactory);
    }

    getThreadCategories(context: ClientContext): AxiosPromise<ThreadCategoriesResponse> {
        const client = this.getClient(context);
        return client.getThreadCategories();
    }

    updateThreadCategories(
        context: ClientContext,
        data: { categories: ThreadCategoryFormData[] },
        extraConfig?: { cancelKey?: string | symbol }
    ): AxiosPromise<ThreadCategoriesResponse> {
        const client = this.getClient(context);
        return client.updateThreadCategories(data, extraConfig);
    }
}

export default new ThreadCategoriesClient();
